import React from 'react'
import { useForm } from 'react-hook-form'
import { Form } from 'react-bootstrap'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { message } from 'antd'
import moment from 'moment'

import ContestForm from './ContestForm'

import { updateContest } from '../services'
import { handleError } from '../../../helpers'

export default function EditContestModal({ visible, onClose, reload, contest }) {
	const { register, handleSubmit, formState: { errors } } = useForm({
		defaultValues: { 
			...contest,
			expire_at: moment(contest.expire_at).format('YYYY-MM-DD'),
			is_published: contest.is_published ? 1 : 0
		}
	})

	const onSubmit = values => {
		updateContest(contest.id, values)
			.then(res => {
				message.success(res.data.message)
				reload()
			})
			.catch(error => handleError(error))
	}

	return (
		<React.Fragment>
			<Modal isOpen={visible} toggle={onClose}>
				<ModalHeader toggle={onClose}>Actualizar Registro</ModalHeader>
				<ModalBody>
					<Form onSubmit={handleSubmit(onSubmit)}>
						<ContestForm register={register} errors={errors} contest={contest} />
						<Button color="primary" type="submit">Actualizar Registrar</Button>
					</Form>
				</ModalBody>
			</Modal>
		</React.Fragment>
	)
}